import React from "react";
import { useHistory } from "react-router-dom";
import { Form, Button, Card, Space } from "antd";
import { toast } from "react-toastify";
import FormFields from "./FormFields";
import { useDispatch, useSelector } from "react-redux";
import { addProduct } from "../../../redux/slices/products/productsThunk";

const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 12 },
};

const tailLayout = {
  wrapperCol: { offset: 8, span: 16 },
};

const AddProductPage = () => {
  const product_loading = useSelector((state) => state.products.product.loading);
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const history = useHistory();

  const onFinish = (values) => {
    dispatch(addProduct(values)).then((res) => {
      if (res.meta.requestStatus === "fulfilled") {
        toast.success("Succès d'ajout!");
        form.resetFields();
        navigateTo("/produit");
      } else {
        toast.error("Erreur pendant l'ajout!");
      }
    });
  };

  const navigateTo = (path) => {
    history.push(path);
  };

  const onReset = () => {
    form.resetFields();
  };

  return (
    <div>
      <Card
        bordered
        className="criclebox tablespace mb-24"
        title="Ajouter un Produit"
      />
      <Card bordered={false}>
        <Form {...layout} form={form} name="control-hooks" onFinish={onFinish}>
          <FormFields />
          <Form.Item {...tailLayout}>
            <Space size="small">
              <Button type="primary" htmlType="submit" 
              loading={product_loading}
              >
                Enregistrer
              </Button>
              <Button htmlType="button" onClick={onReset}>
                Reset
              </Button>
              <Button
                type="link"
                htmlType="button"
                onClick={() => navigateTo("/produit")}
              >
                Annuler
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default AddProductPage;
